export const MAP_JSON_ENDPOINTS = {
  local: '/order-now-config.json',
  production: '/order-now/order-now-config.json?v=23',
};
